<script>
import { BCardText } from "bootstrap-vue";

export default {
  extends: BCardText
};
</script>